import './../../style/dragDrop.css';
import {audioBaseURL } from "../../constants"
import {parseContent} from "./util"

export default function DragElement({correctIndex, content, informAboutDrag, informAboutDrop}) {


    const dragStart = (event) => {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData("text", content + "being dragged");
        const data = event.dataTransfer.getData("text")
        informAboutDrag(correctIndex, content)
    }

    const dragEnd = (event) => {
        informAboutDrop()
    }

    const drop = () => {
    }






    return (
        <div className='dndItem dragElement' draggable="true"
            onDragStart={dragStart}
            onDragEnd={dragEnd}
            onDrop={drop}
            >
            {parseContent(content) &&
            <div className="dndItemContentWrapper ">
                <div className="" 
                    dangerouslySetInnerHTML={{__html: parseContent(content).contentBeforeAudio}}  
                />
                {parseContent(content).audioFileName && <div><audio controls src={audioBaseURL + parseContent(content).audioFileName}  ></audio></div>}
                {parseContent(content).contentAfterAudio && 
                <div className="" 
                    dangerouslySetInnerHTML={{__html: parseContent(content).contentAfterAudio}}  
                /> }
            </div>
            }
            {
        //    <div>
        //        (correct: {correctIndex + 1})
        //    </div>
            }
        </div>

                
    )
}

